/**
 * Compresses an image file by reducing its quality while maintaining original dimensions.
 * Uses HTML Canvas for processing.
 * 
 * @param {File} file - The image file to compress.
 * @param {number} quality - The quality of the output JPEG (0 to 1). Default is 0.7.
 * @returns {Promise<Blob>} - A promise that resolves to the compressed Blob.
 */
export const compressImage = (file, quality = 0.7) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                try {
                    const canvas = document.createElement('canvas');
                    // Maintain original dimensions
                    canvas.width = img.width;
                    canvas.height = img.height;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    // Export as JPEG with reduced quality
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                // Create a new File object to retain the original name and interaction properties
                                const compressedFile = new File([blob], file.name, {
                                    type: 'image/jpeg',
                                    lastModified: Date.now(),
                                });
                                resolve(compressedFile);
                            } else {
                                reject(new Error('Canvas toBlob failed'));
                            }
                        },
                        'image/jpeg',
                        quality
                    );
                } catch (error) {
                    reject(error);
                }
            };
            img.onerror = (error) => reject(error);
        };
        reader.onerror = (error) => reject(error);
    });
};
